module.exports = __webpack_public_path__ + "img/wa-p.6f6bbb16.png";